export default __webpack_public_path__ + "5b40875ae534dff3e228e37fd05d386e.jpg";